import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  loadingList: [],
  showLeftbarDrawer: false,
  showFormLeftbar: true,
  showFormRightbar: true,
  routeFrom: null
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  // SET_CURRENT_NODE: (state, payload) => {
  //   state.currentNode = payload
  // }
  setShowLeftbarDrawer: (state, payload) => {
    state.showLeftbarDrawer = payload
  },
  setShowFormLeftbar: (state, payload) => {
    state.showFormLeftbar = payload
  },
  setShowFormRightbar: (state, payload) => {
    state.showFormRightbar = payload
  },
  setRouteFrom: (state, payload) => {
    state.routeFrom = payload
  },
  ADD_LOADING: (state, payload) => {
    state.loadingList.push(payload)
    console.log(state.loadingList)
  },
  RM_LOADING: (state, payload) => {
    const i = state.loadingList.findIndex((item) => item === payload)
    if (i > -1) state.loadingList.splice(i, 1)
    console.log(state.loadingList)
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  // setCurrentNode({ commit }, node) {
  //   commit('SET_CURRENT_NODE', node)
  // }
  setShowLeftbarDrawer({ commit }, payload) {
    commit('setShowLeftbarDrawer', payload)
  },
  setShowFormLeftbar({ commit }, payload) {
    commit('setShowFormLeftbar', payload)
  },
  setShowFormRightbar({ commit }, payload) {
    commit('setShowFormRightbar', payload)
  },
  setRouteFrom({ commit }, payload) {
    commit('setRouteFrom', payload)
  },
  addLoading({ commit }, loading) {
    commit('ADD_LOADING', loading)
  },
  rmLoading({ commit }, loading) {
    commit('RM_LOADING', loading)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
